import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-two-col-area',
  templateUrl: './two-col-area.component.html',
  styleUrls: ['./two-col-area.component.css']
})
export class TwoColAreaComponent implements OnInit {

  @Input() twoColArea_params: any = {}

  constructor() { }

  ngOnInit(): void {
  }

}
